import { CommonModule } from '@angular/common';
import { Component, DestroyRef, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '../../services/user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ModalService } from '../../services/modal/modal.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-create-user',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;

  constructor(private fb: FormBuilder, private userService: UserService, private authService: AuthenticationService,
    private modalService: ModalService, private vcr: ViewContainerRef, private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      username: fb.control('', [Validators.required, Validators.minLength(4)]),
      email: fb.control('', [Validators.required, Validators.email])
    });
  }

  createUser() {
    if(this.form.valid) {
      this.error = undefined;
      this.submitting = true;

      this.userService.createUser(this.form.value)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.submitting = false;
          this.form.reset();
          this.modalService.showSuccessDialog(this.vcr, 'New user has been created.');
        },
        error: (err: HttpErrorResponse) => {
          if(err.status == 401) {
            this.authService.logout();
          } else {
            this.submitting = false;
            this.error = err.error.message;
          }
        }
      });
    } else {
      this.error = 'Please fill all field properly.';
    }
  }
}
